import { validators } from 'vue-form-generator';

export default {
  model: {
    name: 'customObject1',
    description: '',
  },
  schema: {
    fields: [
      {
        type: 'input',
        inputType: 'text',
        label: 'Name',
        model: 'name',
        placeholder: 'Your name',
        required: true,
        validator: validators.string,
      },
      {
        type: 'textArea',
        label: 'Description',
        model: 'description',
        placeholder: 'Custom Object description',
        required: true,
        max: 500,
        rows: 4,
      },
      {
        type: 'submit',
        buttonText: 'Submit',
      },
    ],
  },
  formOptions: {
    validateAfterLoad: true,
    validateAfterChanged: true,
  },
  permissions: {
    model: {
      adminPermissions: [],
      publicPermissions: [],
    },
    schema: {
      groups: [
        {
          legend: 'Admin permissions',
          fields: [
            {
              type: 'checkbox',
              label: 'Read',
              id: 'adminPermissionRead',
              model: 'adminPermissionRead',
            },
            {
              type: 'checkbox',
              label: 'Edit',
              id: 'adminPermissionEdit',
              model: 'adminPermissionEdit',
            },
            {
              type: 'checkbox',
              label: 'Create',
              id: 'adminPermissionCreate',
              model: 'adminPermissionCreate',
            },
            {
              type: 'checkbox',
              label: 'Delete',
              id: 'adminPermissionDelete',
              model: 'adminPermissionDelete',
            },
          ],
        },
        {
          legend: 'Public permissions',
          fields: [
            {
              type: 'checkbox',
              label: 'Read',
              id: 'publicPermissionRead',
              model: 'publicPermissionRead',
            },
            {
              type: 'checkbox',
              label: 'Edit',
              id: 'publicPermissionEdit',
              model: 'publicPermissionEdit',
            },
            {
              type: 'checkbox',
              label: 'Create',
              id: 'publicPermissionCreate',
              model: 'publicPermissionCreate',
            },
            {
              type: 'checkbox',
              label: 'Delete',
              id: 'publicPermissionDelete',
              model: 'publicPermissionDelete',
            },
          ],
        },
      ],
    },
    formOptions: {
      validateAfterLoad: true,
      validateAfterChanged: true,
    },
  },
  newField: {
    model: {
      name: '',
      description: '',
      type: '',
      length: '',
      default: '',
      required: '',
      drops: '',
      adminPermissions: [],
      publicPermissions: [],
    },
    schema: {
      groups: [
        {
          legend: 'New Field',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Name',
              model: 'name',
              placeholder: 'Unanmed field',
              required: true,
              validator: validators.string,
            },
            {
              type: 'textArea',
              model: 'description',
              placeholder: 'No description',
              required: true,
              max: 500,
              rows: 4,
            },
          ],
        },
        {
          legend: 'Field content',
          fields: [
            {
              type: 'select',
              label: 'Type',
              model: 'type',
              values: ['integer'],
              styleClasses: 'form-group--inline',
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Length',
              model: 'length',
              styleClasses: 'form-group--inline',
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Default',
              model: 'default',
              styleClasses: 'form-group--inline',
            },
            {
              type: 'radios',
              label: 'Required',
              model: 'required',
              values: [
                'Yes',
                'No',
              ],
              styleClasses: 'form-group--inline',
            },
            {
              type: 'radios',
              label: 'Drops',
              model: 'drops',
              values: [
                'Yes',
                'No',
              ],
              styleClasses: 'form-group--inline',
            },
            {
              type: 'checklist',
              label: 'Admin Permissions',
              model: 'adminPermissions',
              listBox: false,
              values: [
                'Read',
                'Edit',
                'Create',
                'Delete',
              ],
              styleClasses: 'form-group--inline',
            },
            {
              type: 'checklist',
              label: 'Public Permissions',
              model: 'publicPermissions',
              listBox: false,
              values: [
                'Read',
                'Edit',
                'Create',
                'Delete',
              ],
              styleClasses: 'form-group--inline',
            },
            {
              type: 'submit',
              buttonText: 'Save field',
            },
          ],
        },
      ],
    },
    formOptions: {
      validateAfterLoad: false,
      validateAfterChanged: true,
    },
  },
  newRelationship: {
    model: {
      sourceObject: 'customObject1',
      type: 'has many',
      targetObject: 'Services',
    },
    schema: {
      groups: [
        {
          legend: 'New Relationship',
          fields: [
            {
              type: 'select',
              label: 'Source object',
              model: 'sourceObject',
              values: ['customObject1'],
            },
            {
              type: 'select',
              label: 'Relationship type',
              model: 'type',
              values: ['has many', 'has one'],
            },
            {
              type: 'select',
              label: 'Object',
              model: 'targetObject',
              values: ['Services'],
            },
            {
              type: 'submit',
              buttonText: 'Save relationship',
            },
          ],
        },
      ],
    },
    formOptions: {
      validateAfterLoad: true,
      validateAfterChanged: true,
    },
  },
};
